const CONTINUE_WATCHING_PREFIX = '@CONTINUE_WATCHING';

export const FETCH = `${CONTINUE_WATCHING_PREFIX}/FETCH`;
export const FETCH_SUCCESS = `${CONTINUE_WATCHING_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${CONTINUE_WATCHING_PREFIX}/FETCH_ERROR`;

export const LOAD_EXTRA_ITEMS = `${CONTINUE_WATCHING_PREFIX}/LOAD_EXTRA_ITEMS`;
export const LOAD_EXTRA_ITEMS_SUCCESS = `${CONTINUE_WATCHING_PREFIX}/LOAD_EXTRA_ITEMS_SUCCESS`;
export const LOAD_EXTRA_ITEMS_ERROR = `${CONTINUE_WATCHING_PREFIX}/LOAD_EXTRA_ITEMS_ERROR`;
export const LOAD_EXTRA_ITEMS_COMPLETED = `${CONTINUE_WATCHING_PREFIX}/LOAD_EXTRA_ITEMS_COMPLETED`;

export const REMOVE_ITEM = `${CONTINUE_WATCHING_PREFIX}/REMOVE_ITEM`;

export const RESET_ALL_DATA = `${CONTINUE_WATCHING_PREFIX}/RESET_ALL_DATA`;
